const {
  GET_MANAGE_ROLES,
  GET_MANAGE_ROLES_FORM,
} = require("src/actions/types");

const initialState = { RolesList: [] };

const ManageRolesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_MANAGE_ROLES:
      return {
        ...state,
        RolesList: payload,
      };
    case GET_MANAGE_ROLES_FORM:
      return {
        ...state,
        RolesListForm: payload,
      };
    default:
      return state;
  }
};

export { ManageRolesReducer };
